const COMBINING_DIACRITICS_RANGE_START = 0x0300;
const COMBINING_DIACRITICS_RANGE_END = 0x036f;

function isCombiningDiacritic(charCode: number): boolean {
  return charCode >= COMBINING_DIACRITICS_RANGE_START && charCode <= COMBINING_DIACRITICS_RANGE_END;
}

export function normalizeForSearch(value: string | null | undefined): string {
  if (!value) return '';
  const decomposed = value.normalize('NFD');
  let result = '';
  for (let i = 0; i < decomposed.length; i++) {
    if (!isCombiningDiacritic(decomposed.charCodeAt(i))) {
      result += decomposed[i];
    }
  }
  return result.toLowerCase();
}
